var PaginatorComponent = Vue.component('app-paginator', {
    props: {
        'baseUrl': String,
        'count': Number,
        'perPageCount': Number,
        'startPage': {
            'type': Number,
            'required': false,
            'default': 1
        },
        'modulus': {
            'type': Number,
            'required': false,
            'default': 1
        },
        'preventClick': {
            'type': Boolean,
            'required': false,
            'default': true
        },
        "pageUrlParameter": {
            'type': String,
            'required': false,
            'default': 'page'
        }
    },
    data: function() {
        return {
            page: this.startPage
        };
    },
    methods: {
        pageClick: function(event, page) {
            if (event && this.preventDefault) {
                event.preventDefault();
            }

            if (this.count == 0 || page == this.page || page < 1 || page > this.count) {
                return false;
            }

            this.page = page;
            this.$emit('pageClick', this.page);
        },
        nextPageClick: function(event) {
            return this.pageClick(event, page + 1);
        },
        prevPageClick: function(event) {
            return this.pageClick(event, page - 1);
        },
        loadMore: function(event) {
            if (event && this.preventDefault) {
                event.preventDefault();
            }

            this.page = this.page + 1;
            this.$emit('loadMore', this.page);
        },
        buildPageUrl: function(page) {
            return this.baseUrl + "?" + this.pageUrlParameter + "=" + page;
        }
    },
    computed: {
        pagesCount: function() {
            if (this.count == 0) {
                return 0;
            }

            return Math.ceil(this.count / this.perPageCount);
        },
        showPrevPage: function() {
            return this.page > 1;
        },
        showNextPage: function() {
            return this.pagesCount > 1 && this.page != this.pagesCount;
        },
        showStartPage: function() {
            return this.page - this.modulus > 1;
        },
        showEndPage: function() {
            return this.page + this.modulus < this.pagesCount;
        },
        prevPages: function() {
            var pages = [];
            var modulus = this.modulus;

            // first page
            if (this.page - 1 == 0) {
                return [];
            }

            // not many pages before
            if (this.page - modulus <= 0) {
                modulus = this.page - 1;
            }   

            for (var i = 1; i <= modulus; i++) {
                var p = this.page - i;

                pages.push({
                    url: this.buildPageUrl(p),
                    page: p
                });
            }

            return pages;
        },
        nextPages: function() {
            var pages = [];
            var modulus = this.modulus;

            // last page
            if (this.page == this.pagesCount) {
                return [];
            }

            // not many pages after
            if (this.page + modulus >= this.pagesCount) {
                modulus = this.pagesCount - this.page;
            }   

            for (var i = 1; i <= modulus; i++) {
                var p = this.page + i;

                pages.push({
                    url: this.buildPageUrl(p),
                    page: p
                });
            }

            return pages;
        }
    }
});